import React from 'react'
import {CNavGroup, CNavItem, CNavTitle, CNavbar} from '@coreui/react'
import {useSelector} from "react-redux";

const navigation = (props) => {
    console.log("### nav.js ###");
    const {user} = useSelector((props) => props.account);
    if (user === undefined) {
        return;
    }

    const authority = user.authority;
    console.log(">>> 권한 :: ", authority);

    // todo USER_MENU 테이블 연동해서 메뉴 권한 지정 기능 추가 전까지는 이쪽에서 수기로 관리
    let _nav;
    if (authority === "ROLE_STORE_ADMIN"  || authority ===  "ROLE_STORE_MANAGER") {
        _nav = [
            {
                component: CNavItem,
                name: '간편재고관리',
                to: '/stock/simple-stock-manage',
                auth: "3"
            },
            {
                component: CNavGroup,
                name: '매출현황',
                items: [
                    {
                        component: CNavItem,
                        name: '당일-매출상세',
                        to: '/sale/currentSale',
                        auth: "3"
                    },
                    {
                        component: CNavItem,
                        name: '영수증별 매출상세현황',
                        to: '/sale/billSaleDetailReport',
                        auth: "3"
                    },
                    {
                        component: CNavItem,
                        name: '코너별 매출현황',
                        to: '/sale/cornerSaleReport',
                        auth: "3"
                    },
                    {
                        component: CNavItem,
                        name: '상품별 매출현황',
                        to: '/sale/productSales',
                        auth: "3"
                    },
                    {
                        component: CNavItem,
                        name: '신용카드 승인현황',
                        to: '/sale/cardSaleReport',
                        auth: "3"
                    },
                ],
            },
        ]
    }
    else if (authority === "ROLE_BRAND_MANAGER")  {
        _nav = [
            {
                component: CNavGroup,
                name: '매출현황',
                items: [
                    {
                        component: CNavItem,
                        name: '당일-매출상세',
                        to: '/sale/currentSale',
                        auth: "3"
                    },
                    {
                        component: CNavItem,
                        name: '영수증별 매출상세현황',
                        to: '/sale/billSaleDetailReport',
                        auth: "3"
                    },
                    {
                        component: CNavItem,
                        name: '코너별 매출현황',
                        to: '/sale/cornerSaleReport',
                        auth: "3"
                    },
                    {
                        component: CNavItem,
                        name: '상품별 매출현황',
                        to: '/sale/productSales',
                        auth: "3"
                    },
                    {
                        component: CNavItem,
                        name: '시간대별 매출현황',
                        to: '/sale/hourlySaleReport',
                        auth: "3"
                    },
                ],
            },
        ]
    }
    else {
        _nav = [
            {
                id: 0,
                component: CNavItem,
                name: '대시보드',
                to: '/main',
                auth: "3"
            },
            {
                component: CNavGroup,
                name: '휴게소관리',
                items: [
                    {
                        id: 1,
                        component: CNavItem,
                        name: '휴게소 정보관리',
                        to: '/brand/list',
                        auth: "1"
                    }
                ]
            },
            {
                component: CNavGroup,
                name: '매장관리',
                items: [
                    {
                        id: 2,
                        component: CNavItem,
                        name: '매장 정보관리',
                        to: '/store/manage',
                        auth: "1"
                    },
                    {
                        id: 3,
                        component: CNavItem,
                        name: '매장 정보조회',
                        to: '/store/store-list',
                        auth: "2"
                    },
                    {
                        id: 4,
                        component: CNavItem,
                        name: '점포POS 장비관리',
                        to: '/store/device',
                        auth: "2"
                    },
                    {
                        id: 5,
                        component: CNavItem,
                        name: '주방프린터 설정',
                        to: '/store/kitchen',
                        auth: "2"
                    },
                    {
                        id: 6,
                        component: CNavItem,
                        name: '매장 사용자 관리',
                        to: '/store/pos-user',
                        auth: "2"
                    }
                    , {
                        id: 7,
                        component: CNavItem,
                        name: 'POS환경설정 관리',
                        to: '/store/config',
                        auth: "2"
                    },
                    {
                        id: 8,
                        component: CNavItem,
                        name: 'KIOSK 환경설정 관리',
                        to: '/store/kiosk/config',
                        auth: "2"
                    },
                    {
                        id: 9,
                        component: CNavItem,
                        name: '점포 환경설정 복사',
                        to: '/store/copy',
                        auth: "2"
                    }
                ],
            },
            {
                component: CNavGroup,
                name: '상품관리',
                items: [
                    {
                        id: 10,
                        component: CNavItem,
                        name: '상품등록',
                        to: '/product/register',
                        auth: "1"
                    },
                    {
                        id: 11,
                        component: CNavItem,
                        name: '취급상품관리',
                        to: '/product/handling',
                        auth: "0"
                    },
                    {
                        id: 12,
                        component: CNavItem,
                        name: '휴게소별 판매가/시간 관리',
                        to: '/product/chain',
                        auth: "0"
                    },
                    {
                        id: 13,
                        component: CNavItem,
                        name: '상품조회',
                        to: '/product/search',
                        auth: "3"
                    },
                    {
                        id: 14,
                        component: CNavItem,
                        name: '상품 다국어관리',
                        to: '/product/language',
                        auth: "0"
                    },
                    {
                        id: 15,
                        component: CNavItem,
                        name: '판매상품-브랜드 연결',
                        to: '/product/mapping',
                        auth: "0"
                    },
                ],
            },
            {
                component: CNavGroup,
                name: '매출현황',
                items: [
                    {
                        id: 16,
                        component: CNavItem,
                        name: '당일-매출상세',
                        to: '/sale/currentSale',
                        auth: "3"
                    },
                    {
                        id: 17,
                        component: CNavItem,
                        name: '영수증별 매출상세현황',
                        to: '/sale/billSaleDetailReport',
                        auth: "3"
                    },
                    {
                        id: 18,
                        component: CNavItem,
                        name: '코너별 매출현황',
                        to: '/sale/cornerSaleReport',
                        auth: "3"
                    },
                    {
                        id: 19,
                        component: CNavItem,
                        name: '상품별 매출현황',
                        to: '/sale/productSales',
                        auth: "3"
                    },
                    {
                        id: 20,
                        component: CNavItem,
                        name: '시간대별 매출현황',
                        to: '/sale/hourlySaleReport',
                        auth: "3"
                    },
                    {
                        id: 21,
                        component: CNavItem,
                        name: '판매반품현황',
                        to: '/sale/saleRejectReport',
                        auth: "3"
                    },
                    {
                        id: 22,
                        component: CNavItem,
                        name: 'ERP 자료',
                        to: '/sale/erp-data',
                        auth: "3"
                    },
                    {
                        id: 23,
                        component: CNavItem,
                        name: '신용카드 승인현황',
                        to: '/sale/cardSaleReport',
                        auth: "3"
                    },
                    {
                        id: 24,
                        component: CNavItem,
                        name: '도로공사 매출현상 대사',
                        to: '/sale/compareSaleTR',
                        auth: "3"
                    },
                    {
                        id: 25,
                        component: CNavItem,
                        name: '매출 수기등록',
                        to: '/sale/manual/ManualSaleRegister',
                        auth: "3"
                    },
                    {
                        id: 26,
                        component: CNavItem,
                        name: '매출자료 삭제',
                        to: '/sale/manual/deleteSaleData',
                        auth: "3"
                    }
                ],
            },
            {
                component: CNavGroup,
                name: '판매보고서',
                items: [
                    {
                        id: 27,
                        component: CNavItem,
                        name: '일일영업 판매보고서',
                        to: '/report/SaleReport',
                        auth: "3"
                    },
                    {
                        id: 28,
                        component: CNavItem,
                        name: '마감자료 수기등록',
                        to: '/sale/manual/RegisterSaleCl',
                        auth: "3"
                    }
                ],
            },
            {
                component: CNavGroup,
                name: '재고변경관리',
                items: [
                    {
                        id: 29,
                        component: CNavItem,
                        name: '간편재고관리',
                        to: '/stock/simple-stock-manage',
                        auth: "3"
                    },
                ],
            },
            // {
            //     component: CNavGroup,
            //     name: '기타관리',
            //     items: [
            //         {
            //             id: 29,
            //             component: CNavItem,
            //             name: '공지사항 조회',
            //             to: '/board/notice',
            //             auth: "3"
            //         },
            //     ],
            // },
            // {
            //     component: CNavGroup,
            //     name: '시스템관리',
            //     items: [
            //         {
            //             id: 30,
            //             component: CNavItem,
            //             name: '메뉴 등록관리',
            //             to: '/system/menu/list',
            //             auth: "1"
            //         },
            //         {
            //             id: 31,
            //             component: CNavItem,
            //             name: '테이블 관리',
            //             to: '/table/manage',
            //             auth: "1"
            //         }
            //     ]
            // },
        ]
    }
    return _nav;
}

export default navigation;
